import { React, useEffect, useState, } from "react";
import { useTheme } from "@mui/material/styles";
import {
    Menu, MenuItem, Tooltip, List, Typography, ListItem, ListItemButton, ListItemIcon, ListItemText,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation, Link } from 'react-router-dom';
import {
    RiBarChartBoxFill, RiBarChartBoxLine, RiSensorFill,
    RiSensorLine,
    RiShiningFill,
    RiShiningLine,
    RiRamFill,
    RiRamLine,
    RiInputField,
    RiListSettingsFill,
    RiListSettingsLine,
    RiUserSettingsLine,
    RiUserSettingsFill,
    RiDeviceFill,
    RiRouterLine,
    RiMapPinLine,
    RiMapLine,
    RiFileList2Line,
    RiAlarmWarningLine,
    RiRouterFill,
    RiDeviceLine,
    RiDatabaseFill,
    RiDatabaseLine,
    RiMapPinUserLine,
    RiMapPinUserFill,
    RiMapPinFill,
    RiMapFill,
    RiFileList2Fill,
    RiAlarmWarningFill,
    RiDashboardLine,
    RiCompass3Line,
    RiPlantFill,
    RiPlantLine
} from "@remixicon/react";
import { Timeline, Assessment } from "@mui/icons-material";

function MainMenu(props) {
    const theme = useTheme();
    const location = useLocation()
    const { menus, permissions } = useSelector(
        (state) => state.menu.roleWiseData
    );
    const [menuanchorEl, setmenuAnchorEl] = useState(null);
    const [openPage, setOpenPage] = useState("");
    const [showMenu, setShowMenu] = useState("");

    useEffect(() => {
        const setRoute = () => {
            let route = location.pathname.replace(/\//, '');
            setOpenPage(route);
        }

        setRoute();
    }, [location]);

    const handleClose = () => {
        setmenuAnchorEl(null);
    };

    const keepState = (event) => {
        setmenuAnchorEl(menuanchorEl);
    };

    const openMenu = Boolean(menuanchorEl);
    const handleClick = (event, item) => {
        setShowMenu(item);
        setmenuAnchorEl(event.currentTarget);
    };
    return (
        <List>
            <>
                {/* front user menu start*/}
                {/* Dashboard*/}
                {menus && menus.filter((data) => data.alias_name === "dashboard").length > 0 ?
                    <Link to="/dashboard" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Dashboard"}>
                                <ListItemButton
                                    selected={openPage === 'dashboard' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "/dashboard" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "dashboard" ? <RiBarChartBoxFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiBarChartBoxLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Dashboard" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* {menus && menus.filter((data) => data.alias_name === "tracking").length > 0 ? */}
                <Link to="/pages/sessions" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                    <ListItem disablePadding sx={{ display: "block" }}>
                        <Tooltip placement="right" title={props.drawerOpen ? null : "Tracking"}>
                            <ListItemButton
                                selected={openPage === 'pages/sessions' ? true : false}
                                sx={{
                                    minHeight: 48,
                                    justifyContent: props.drawerOpen ? "initial" : "center",
                                    px: 2.5,
                                    color: openPage === "/pages/sessions" ? theme.palette.primary.main : "inherit"
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: props.drawerOpen ? 3 : "auto",
                                        justifyContent: "center",
                                    }}
                                >
                                    {openPage === "pages/sessions" ? <Timeline style={{ color: theme.palette.primary.main }} />
                                        :
                                        <Timeline style={{ color: "inherit" }} />
                                    }
                                </ListItemIcon>
                                <ListItemText primary="Tracking" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                {/* : ""} */}


                {/* {menus && menus.filter((data) => data.alias_name === "tracking").length > 0 ? */}
                <Link to="pages/sessions-doctors" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                    <ListItem disablePadding sx={{ display: "block" }}>
                        <Tooltip placement="right" title={props.drawerOpen ? null : "Monitoring"}>
                            <ListItemButton
                                selected={openPage === 'pages/sessions-doctors' ? true : false}
                                sx={{
                                    minHeight: 48,
                                    justifyContent: props.drawerOpen ? "initial" : "center",
                                    px: 2.5,
                                    color: openPage === "pages/sessions-doctors" ? theme.palette.primary.main : "inherit"
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: props.drawerOpen ? 3 : "auto",
                                        justifyContent: "center",
                                    }}
                                >
                                    {openPage === "pages/sessions-doctors" ? <Assessment style={{ color: theme.palette.primary.main }} />
                                        :
                                        <Assessment style={{ color: "inherit" }} />
                                    }
                                </ListItemIcon>
                                <ListItemText primary="Monitoring" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                {/* : ""} */}

                {menus && menus.filter((data) => data.alias_name === "user_location").length > 0 ?
                    <Link to="/front/userSensor/floor-list" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "Location"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'location')}
                                    onMouseLeave={handleClose}
                                    selected={openPage.includes('floor-list') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('floor-list') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('floor-list') ? <RiMapPinUserFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiMapPinUserLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Location" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}

                {/* Devices User Sensors*/}
                {menus && menus.filter((data) => data.alias_name === "gateway").length > 0 ?
                    <Link to="/front/userSensor/sensors" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Devices"}>
                                <ListItemButton
                                    selected={openPage === 'front/userSensor/sensors' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "front/userSensor/sensors" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "front/userSensor/sensors" ? < RiDeviceFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiDeviceLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Devices" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* Gateway*/}
                {menus && menus.filter((data) => data.alias_name === "gateway").length > 0 ?
                    <Link to="/front/manage/gateway" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Gateways"}>
                                <ListItemButton
                                    selected={openPage === 'front/manage/gateway' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "front/manage/gateway" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "front/manage/gateway" ? <RiRouterFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiRouterLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Gateways" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}

                {/* minew */}
                {menus && menus.filter((data) => data.alias_name === "user_location").length > 0 ?
                    <Link to="/front/storeProduct" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "ELS Tags"}>
                                <ListItemButton
                                    // onMouseEnter={(event) => handleClick(event, 'minew1')}
                                    // onMouseLeave={handleClose}
                                    selected={openPage.includes('/front/storeProduct') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('/front/storeProduct') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('/front/storeProduct') ? <RiPlantFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiPlantLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="ELS Tags" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}

                {/* Site Dashboard page  */}
                {false && menus && menus.filter((data) => data.alias_name === "dashboard").length > 0 ?
                    <Link to="/site-dashboard" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Site Dashboard"}>
                                <ListItemButton
                                    selected={openPage === 'site-dashboard' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "/site-dashboard" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "site-dashboard" ? <RiBarChartBoxFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiBarChartBoxLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Site Dashboard" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* {menus && menus.filter((data) => data.alias_name === "dashboard").length > 0 ?
                    <Link to="/device-manager" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Controls "}>
                                <ListItemButton
                                    selected={openPage === 'device-manager' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "/device-manager" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "device-manager" ? <RiDashboardLine style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiDashboardLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Controls" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""} */}


                {/* {menus && menus.filter((data) => data.alias_name === "dashboard").length > 0 ?
                    <Link to="/manage/sensor-management/relay" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Relay"}>
                                <ListItemButton
                                    selected={openPage === '/manage/sensor-management/relay' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "/manage/sensor-management/relay" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "Relay" ? <RiBarChartBoxFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiBarChartBoxLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Relay" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""} */}

                {/* {menus && menus.filter((data) => data.alias_name === "dashboard").length > 0 ?
                    <Link to="/front/userRelay" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "User Relay"}>
                                <ListItemButton
                                    selected={openPage === 'front/userRelay' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "/front/userRelay" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "User Relay" ? <RiBarChartBoxFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiBarChartBoxLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="User Relay" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""} */}

                {/* Gateway*/}
                {false && menus && menus.filter((data) => data.alias_name === "gateway").length > 0 ?
                    <Link to="/front/sites" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Sites"}>
                                <ListItemButton
                                    selected={openPage === '/front/sites' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "/front/sites" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "/front/sites" ? < RiMapPinFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiMapPinLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Sites" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}

                {/* Gateway*/}
                {false && menus && menus.filter((data) => data.alias_name === "gateway").length > 0 ?
                    <Link to="/front/userSensor/floor-map" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Maps"}>
                                <ListItemButton
                                    selected={openPage === 'front/userSensor/floor-map' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "front/userSensor/floor-map" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "front/userSensor/floor-map" ? < RiMapFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiMapLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Maps" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* Alerts Pages*/}
                {menus && menus.filter((data) => data.alias_name === "gateway").length > 0 ?
                    <Link to="/front/alerts" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Alerts"}>
                                <ListItemButton
                                    selected={openPage === 'front/alerts' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "front/alerts" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "front/alerts" ? < RiAlarmWarningFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiAlarmWarningLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Alerts" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}

                {/* Logs Pages*/}
                {menus && menus.filter((data) => data.alias_name === "gateway").length > 0 ?
                    <Link to="/front/logs" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <Tooltip placement="right" title={props.drawerOpen ? null : "Logs"}>
                                <ListItemButton
                                    selected={openPage === 'front/logs' ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "front/logs" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "front/logs" ? < RiFileList2Fill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiFileList2Line style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Logs" sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}








                {/* front sensor menu */}
                {false && menus && menus.filter((data) => data.alias_name === "user_sensors").length > 0 ?
                    <Link to="/front/userSensor/sensors" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "User Sensors"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'front_user_sensors')}
                                    onMouseLeave={handleClose}
                                    selected={openPage.includes('front/userSensor') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('front/userSensor') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('front/userSensor') ? <RiRamFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiRamLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="User Sensors" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* front gateway menu */}
                {menus && menus.filter((data) => data.alias_name === "front_manage").length > 0 ?
                    <Link to="/front/notification" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "front_manage"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'front_manage')}
                                    onMouseLeave={handleClose}
                                    selected={openPage === "/front/notification" ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage === "/front/notification" ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage === "/front/notification" ? <RiDeviceFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiDeviceLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Settings" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}

                {/* front user menu End*/}


                {/* Sensor Management */}
                {menus && menus.filter((data) => data.alias_name === "sensor_management").length > 0 ?
                    <Link to="/manage/sensor-management/device-threshold-values" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "Sensor Management"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'sensor_management')} onMouseLeave={handleClose}
                                    selected={openPage.includes('manage/sensor-management') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('manage/sensor-management') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('manage/sensor-management') ? <RiSensorFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiSensorLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Sensor Management" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* miscellaneous */}
                {menus && menus.filter((data) => data.alias_name === "miscellaneous").length > 0 ?
                    <Link to="/manage/miscellaneous/device-manufacturer" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "Miscellaneous"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'miscellaneous')}
                                    onMouseLeave={handleClose}
                                    selected={openPage.includes('manage/miscellaneous') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('manage/miscellaneous') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('manage/miscellaneous') ? <RiShiningFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiShiningLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Miscellaneous" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* gateway menu */}
                {menus && menus.filter((data) => data.alias_name === "gateway_management").length > 0 ?
                    <Link to="/manage/gateway-management/device-gateway" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "Gateway Management"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'gateway_management')}
                                    onMouseLeave={handleClose}
                                    selected={openPage.includes('manage/gateway-management') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('manage/gateway-management') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('manage/gateway-management') ? <RiRamFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiRamLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Gateway Management" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* field management */}
                {menus && menus.filter((data) => data.alias_name === "field_management").length > 0 ?
                    <Link to="/field-management/field-dictionary" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "Field Management"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'field_management')}
                                    onMouseLeave={handleClose}
                                    selected={openPage.includes('field-management') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('field-management') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('field-management') ? <RiInputField style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiInputField style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Field Management" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* menu management */}
                {menus && menus.filter((data) => data.alias_name === "menus_management").length > 0 ?
                    <Link to="/administration/menuManagement/menus" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "Menu Management"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'menu_management')}
                                    onMouseLeave={handleClose}
                                    selected={openPage.includes('administration/menuManagement') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('administration/menuManagement') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('administration/menuManagement') ? <RiListSettingsFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiListSettingsLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Menu Management" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* user management */}
                {menus && menus.filter((data) => data.alias_name === "user_management").length > 0 ?
                    <Link to="/user-management/user" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "User Management"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'user')}
                                    onMouseLeave={handleClose}
                                    selected={openPage.includes('user-management') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('user-management') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('user-management') ? <RiUserSettingsFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiUserSettingsLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="User Management" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}
                {/* log management */}
                {menus && menus.filter((data) => data.alias_name === "log_management").length > 0 ?
                    <Link to="/log-management/access-log" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                        <ListItem disablePadding sx={{ display: "block", zIndex: 1500 }}>
                            <Tooltip disableHoverListener placement="right" title={props.drawerOpen ? null : "Log Management"}>
                                <ListItemButton
                                    onMouseEnter={(event) => handleClick(event, 'log_management')}
                                    onMouseLeave={handleClose}
                                    selected={openPage.includes('log-management') ? true : false}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.drawerOpen ? "initial" : "center",
                                        px: 2.5,
                                        color: openPage.includes('log-management') ? theme.palette.primary.main : "inherit"
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: props.drawerOpen ? 3 : "auto",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {openPage.includes('log-management') ? <RiDatabaseFill style={{ color: theme.palette.primary.main }} />
                                            :
                                            <RiDatabaseLine style={{ color: "inherit" }} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary="Log Management" primaryTypographyProps={{ className: "text-truncate" }} sx={{ opacity: props.drawerOpen ? 1 : 0 }} />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </Link>
                    : ""}


            </>

            <Menu
                anchorEl={menuanchorEl}
                open={openMenu}
                disableRestoreFocus
                disablePortal
                hideBackdrop
                elevation={0}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handleClose}
                slotProps={{ paper: { sx: { background: theme.palette.primary.main, borderRadius: "0 8px 8px 8px" }, elevation: 1, onMouseEnter: keepState, onMouseLeave: handleClose }, }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {showMenu === 'sensor_management' &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>Sensor Management</Typography>

                            {menus && menus.filter((data) => data.alias_name === "sensor_category").length > 0 ?
                                <Link to="manage/sensor-management/categories" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Category</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "sensor_library").length > 0 ?
                                <Link to="/manage/sensor-management/library" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Library</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "device_features").length > 0 ?
                                <Link to="/manage/sensor-management/feature" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Features</MenuItem>
                                </Link>
                                : ""}

                            {menus && menus.filter((data) => data.alias_name === "relay").length > 0 ?
                                <Link to="/manage/sensor-management/relay" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Relay</MenuItem>
                                </Link>
                                : ""}
                        </div>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'></Typography>
                            {menus && menus.filter((data) => data.alias_name === "device_threshold_values").length > 0 ?
                                <Link to="/manage/sensor-management/device-threshold-values" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Device Threshold</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "featuregroups").length > 0 ?
                                <Link to="/manage/sensor-management/feature-group" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Feature Groups</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "threshold_groups").length > 0 ?
                                <Link to="/manage/sensor-management/threshold-group" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Threshold Groups</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "all-user-rule").length > 0 ?
                                <Link to="/manage/sensor-management/all-user-rule" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>All User Rule</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }
                {showMenu === "miscellaneous" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>Miscellaneous</Typography>
                            {menus && menus.filter((data) => data.alias_name === "device_manufacturer").length > 0 ?
                                <Link to="/manage/miscellaneous/device-manufacturer" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Device Manufacturer</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "device_tags").length > 0 ?
                                <Link to="/manage/miscellaneous/device-tags" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Device Tags</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "device_model").length > 0 ?
                                <Link to="/manage/miscellaneous/device-model" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Device Model</MenuItem>
                                </Link>
                                : ""}
                        </div>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'></Typography>
                            {menus && menus.filter((data) => data.alias_name === "device_hw_version").length > 0 ?
                                <Link to="/manage/miscellaneous/device-hw-version" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Device HW Version</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }
                {showMenu === "gateway_management" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>Gateway Management</Typography>
                            {menus && menus.filter((data) => data.alias_name === "device_gateway").length > 0 ?
                                <Link to="/manage/gateway-management/device-gateway" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Device Gateway</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }

                {showMenu === "minew" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'> Store </Typography>
                            {menus && menus.filter((data) => data.alias_name === "user_location").length > 0 ?
                                <Link to="front/data-fields" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Data Fields</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "user_location").length > 0 ?
                                <Link to="front/storeProduct" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Store Data</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }
                {showMenu === "field_management" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>Field Management</Typography>
                            {menus && menus.filter((data) => data.alias_name === "field_dictionary").length > 0 ?
                                <Link to="/field-management/field-dictionary" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Field Dictionary</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "field_groups").length > 0 ?
                                <Link to="/field-management/field-group" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Field Groups</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }
                {showMenu === "menu_management" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>Menu Management</Typography>
                            {menus && menus.filter((data) => data.alias_name === "menus").length > 0 ?
                                <Link to="/administration/menuManagement/menus" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Menus</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "modules").length > 0 ?
                                <Link to="/administration/menuManagement/module" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Module</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }
                {showMenu === "user" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>User Management</Typography>
                            {menus && menus.filter((data) => data.alias_name === "users").length > 0 ?
                                <Link to="/user-management/user" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Users</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "roles").length > 0 ?
                                <Link to="/administration/userManagement/role" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Roles</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "permissions").length > 0 ?
                                <Link to="/user-management/user-permission" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Permission</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }
                {showMenu === "log_management" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>Log Management</Typography>
                            {menus && menus.filter((data) => data.alias_name === "access_log").length > 0 ?
                                <Link to="/log-management/access-log" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Access Log</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "administrative_log").length > 0 ?
                                <Link to="/log-management/administrative-log" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Administrative Log</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "device_log").length > 0 ?
                                <Link to="/log-management/device-log" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Device Log</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }


                {/* =========front user ========= */}
                {showMenu === "location" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>Location</Typography>
                            <Link to="/front/sites" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Sites</MenuItem>
                            </Link>
                            <Link to="/front/userSensor/floor-map" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Maps</MenuItem>
                            </Link>
                            {/* <Link to="/site-dashboard" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Dashboard</MenuItem>
                            </Link> */}
                        </div>
                    </div>
                }
                {showMenu === "front_user_sensors" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>User Sensors</Typography>

                            {/* {menus && menus.filter((data) => data.alias_name === "sensors_list").length > 0 ? */}
                            <Link to="/front/userSensor/sensors" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Sensors List</MenuItem>
                            </Link>
                            {/* : ""} */}
                            {/* {menus && menus.filter((data) => data.alias_name === "floor_map").length > 0 ? */}
                            <Link to="/front/userSensor/floor-map" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Floor Map</MenuItem>
                            </Link>
                            <Link to="/front/userSensor/floor-list" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>Floor List</MenuItem>
                            </Link>
                            {/* : ""} */}
                            {menus && menus.filter((data) => data.alias_name === "user-rule").length > 0 ?
                                <Link to="/front/userSensor/user-rule" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>User Rule</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }
                {showMenu === "front_manage" &&
                    <div className='row p-2 px-3 text-white'>
                        <div className='col-md-6'>
                            <Typography className="px-2 opacity-75" variant='overline'>Settings</Typography>
                            {/* {menus && menus.filter((data) => data.alias_name === "smtp").length > 0 ?
                                <Link to="/front/notification" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded-3 fw-light' onClick={handleClose}>SMTP</MenuItem>
                                </Link>
                                : ""} */}
                            {menus && menus.filter((data) => data.alias_name === "smtp").length > 0 ?
                                <Link to="/front/notification" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 borde/front/notification-3 fw-light' onClick={handleClose}>Notification</MenuItem>
                                </Link>
                                : ""}
                            {menus && menus.filter((data) => data.alias_name === "userRelay").length > 0 ?
                                <Link to="/front/userRelay" style={{ textDecoration: 'inherit', color: 'inherit' }}>
                                    <MenuItem className='py-1 px-2 border-rounded rounded/front/notificationht' onClick={handleClose}>User Relay Management</MenuItem>
                                </Link>
                                : ""}
                        </div>
                    </div>
                }
            </Menu>
        </List>
    );
}

export default MainMenu;